
import moment from 'moment';
import React from 'react';
import { reactAI } from "react-appinsights";
import uuid from 'react-native-uuid';
import {fetchToken} from '../../Util.js';
import {SERVICE_NAME,SERVICE_OFFERING,COMPONENT_NAME,SERVICE_LINE,COMPONENT_ID} from "../../common/Constants/Constants";
import {appInsights} from '../../common/AppInsights/AppInsights';
import AlertDialog from "../../common/AlertDialog/AlertDialog";
import * as Datetime from 'react-datetime';
import { Button,Modal } from 'react-bootstrap';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {ButtonType} from 'office-ui-fabric-react/lib/Button'; 
import { trackPromise } from 'react-promise-tracker'
import LoadingIndicator from '../../common/PromiseTracker/PromiseTracker';
import { string } from 'prop-types';
import ReactFactoryDropDown from '../FactoryDropDown/Factory';
import ReactRegionDropDown from '../RegionDropdown/Region';
import Select from 'react-select';
//import { val } from '../Calendar/BigCalendar.js';
import { getTestparvalue } from '../Calendar/BigCalendar.js';

class AddFactoryProductionEvent extends React.Component{
    _isMounted = false;
    constructor(props) {
    
      super(props);
      
      const date = Date.now();
      this.state = {date: '',enddate:'',clicked:false,result:'',userEmail : '',addevent : false,showModal: '',
        title: '',titleError: '',dateError:'',enddateError : '',hasError:false,
        showDialog: '',showErrorDialog : '',showNewDialog:false,newblocking:false, addOutage:[]
        , role : this.props.role,regionError:'',countryError:'',region:'',country:'',
        category:'',categoryError:'',rowId:'',showEventErrorDialog:'', timezone:"UTC"
      };
      
      this.handleChange = this.handleChange.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onEndChange = this.onEndChange.bind(this);
      this.methodInvoke = this.methodInvoke.bind(this);
      this.close = this.close.bind(this);
      this.cofirmApproveReject = this.cofirmApproveReject.bind(this);
      this.flip = this.flip.bind(this);

     
    }

   
  
    appInsight = reactAI.appInsights;
    close = () => this.setState({isOpen: false}) 
  
    componentDidMount() {
      this._isMounted = true;
    }
  
    componentWillUnmount() {
      this._isMounted = false;
    }
  
    close(){
      this.setState({ showModal: false });
    }

    convertDateToUTC(date)
    {
      var now_utc =  date;
      now_utc.setHours(now_utc.getHours()+5);
      now_utc.setMinutes(now_utc.getMinutes()+30);
      return now_utc.toUTCString();
    }

    // convert CST date to UTC date .
    convertCSTDateToUTC(date)
    {
      var now_cst =  date;
      now_cst.setHours(now_cst.getHours()-8);
      return now_cst.toUTCString();
    }
    // convert PST date to UTC date .
    convertPSTDateToUTC(date)
    {
      var now_pst =  date;
      var isDST=this.checkDateForDaylightSaving(date);
      if (isDST===true)
      {
        now_pst.setHours(now_pst.getHours()+7);
      }
      else
      {
        now_pst.setHours(now_pst.getHours()+8);
      }
      return now_pst.toUTCString();
    }
    // convert UTC date to CST date .
    convertUTCDateToCST(date)
    {
      var now_utc =  date;
      now_utc.setHours(now_utc.getHours()+8);
      return now_utc;
    }
    // convert UTC date to PST date . 
    convertUTCDateToPST(date)
    {
      var now_utc =  date;
      var isDST=this.checkDateForDaylightSaving(date);
      if (isDST===true)
      {
      now_utc.setHours(now_utc.getHours()-7);
      }
      else
      {
        now_utc.setHours(now_utc.getHours()-8);
      }
      return now_utc;
    }

    convertCSTDateToUTCTimezone(date)
    {
      var now_cst =  date;
      now_cst.setHours(now_cst.getHours()-8);
      return now_cst;
    }
    convertPSTDateToUTCTimezone(date)
    {
     var now_pst =  date;
     var isDST=this.checkDateForDaylightSaving(date);
     if (isDST===true)
     {
      now_pst.setHours(now_pst.getHours()+7); //during daylight saving months .
     }
     else
     {
      now_pst.setHours(now_pst.getHours()+8);
     }
      return now_pst;
    }
    convertCSTDateToPST(date)
    {
      var now_cst =  date;
      var isDST=this.checkDateForDaylightSaving(date);
      if (isDST===true)
      {
      now_cst.setHours(now_cst.getHours()-8);
      now_cst.setHours(now_cst.getHours()-7);
      }
      else
      {
        now_cst.setHours(now_cst.getHours()-8);
        now_cst.setHours(now_cst.getHours()-8);
      }
      //return now_cst.toUTCString();
      return now_cst;
    }

    convertPSTDateToCST(date)
    {
      var now_pst =  date;
      var isDST=this.checkDateForDaylightSaving(date);
      if (isDST===true)
      {
      now_pst.setHours(now_pst.getHours()+7);
      now_pst.setHours(now_pst.getHours()+8);
      }
      else
      {
        now_pst.setHours(now_pst.getHours()+8);
        now_pst.setHours(now_pst.getHours()+8);
      }
      //return now_cst.toUTCString();
      return now_pst;
    }

    //calculate daylight saving start date , end date  in a year . 
  
    calculateDSTStartDate()
    {
      const days = {
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
        Sun: 0
      }
     
      var weekNumber,day,monthMoment;
      var year=new Date().getFullYear();
      var marchdate=year+'-03-01';
      var dststartdate;

      // 2nd Sunday of March . 
      weekNumber=2;
      day=days.Sun;
      monthMoment=moment(marchdate);
     
      let m = monthMoment.clone()
         .startOf('month')                     
         .day(day)
        if (m.month() !== monthMoment.month()) 
        {
          m.add(7, 'd');
        }
        //dststartdate= m.add(7 * (weekNumber - 1), 'd').format('YYYY-MM-DDTHH:mm:ss.fff Z');
        dststartdate= m.add(7 * (weekNumber - 1), 'd');
        dststartdate=moment(dststartdate).add(2, 'hours');
        return dststartdate;            
       
    }

    calculateDSTEndDate()
    {
      const days = {
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
        Sun: 0
      }
     
      var weekNumber,day,monthMoment;
      var year=new Date().getFullYear();
      var novdate=year+'-11-01';
      var dstenddate;

      // 1st Sunday of November .  
      weekNumber=1;
      day=days.Sun;
      monthMoment=moment(novdate);

      let m = monthMoment.clone()
      .startOf('month')                     
      .day(day)
       if (m.month() !== monthMoment.month()) 
      {
         m.add(7, 'd');
      }
      //dstenddate= m.add(7 * (weekNumber - 1), 'd').format('YYYY-MM-DDTHH:mm:ss.fff Z');
      dstenddate= m.add(7 * (weekNumber - 1), 'd');
      dstenddate=moment(dstenddate).add(2, 'hours');
      return dstenddate;        
       
    }
    //check daylight saving is active or not . 
    checkDateForDaylightSaving(date)
    {
       var DaylightStartDate= this.calculateDSTStartDate();
       var DaylightEndDate=this.calculateDSTEndDate();
       if(date >= DaylightStartDate && date <=DaylightEndDate)
       {
         return true;
       }
       else
       {
         return false;
       }
    }


    /*  onTimezoneChange=async(event) =>{
      this.setState({ timezone:event.target.value });
      console.log(this.state.timezone );
    } */

    onTimezoneChange=async(e) =>{
      var prevselectedtimezone=this.state.timezone;
      this.selectedtimezoneEventData(e.target.value,prevselectedtimezone);
      this.setState({ timezone:e.target.value });

      console.log(this.state.timezone );
    }

    selectedtimezoneEventData(selectedtimezone,prevselectedtimezone)
    {
        if(prevselectedtimezone==="UTC" || prevselectedtimezone===null || prevselectedtimezone==='' || prevselectedtimezone===undefined)
        {
            if(selectedtimezone==="CST")
            {                         
            /*  this.setState({date:Date.parse(new Date(this.convertUTCDateToCST(new Date(this.state.date)))) , 
                            enddate:Date.parse(new Date(this.convertUTCDateToCST(new Date(this.state.enddate)))) }); */
                if((this.state.date!==null && this.state.date!==undefined && this.state.date!=='') && (this.state.enddate!==null && this.state.enddate!==undefined && this.state.enddate!=='' ))
                {
                    this.setState({date:this.convertUTCDateToCST(new Date(this.state.date)) , 
                            enddate:this.convertUTCDateToCST(new Date(this.state.enddate)) });  
                }          
            }
            else if(selectedtimezone==="PST")
            {  
              if((this.state.date!==null && this.state.date!==undefined && this.state.date!=='') && (this.state.enddate!==null && this.state.enddate!==undefined && this.state.enddate!=='' ))
              {                     
                  this.setState({date:this.convertUTCDateToPST(new Date(this.state.date)) , 
                    enddate:this.convertUTCDateToPST(new Date(this.state.enddate)) });
              }
            }
       }
       else if(prevselectedtimezone==="CST")
       {
            if(selectedtimezone==="UTC")
            {                     
              if((this.state.date!==null && this.state.date!==undefined && this.state.date!=='') && (this.state.enddate!==null && this.state.enddate!==undefined && this.state.enddate!=='' ))
              { 
                  this.setState({date:Date.parse(new Date(this.convertCSTDateToUTCTimezone(new Date(this.state.date)))) , 
                enddate:Date.parse(new Date(this.convertCSTDateToUTCTimezone(new Date(this.state.enddate)))) });
              }
            }
            else if(selectedtimezone==="PST")
            {                  
              if((this.state.date!==null && this.state.date!==undefined && this.state.date!=='') && (this.state.enddate!==null && this.state.enddate!==undefined && this.state.enddate!=='' ))
              {    
                  this.setState({date:this.convertCSTDateToPST(new Date(this.state.date)) , 
                enddate:this.convertCSTDateToPST(new Date(this.state.enddate)) });
              }
            }
       }
       else if(prevselectedtimezone==="PST")
       {
            if(selectedtimezone==="UTC")
            { 
              if((this.state.date!==null && this.state.date!==undefined && this.state.date!=='') && (this.state.enddate!==null && this.state.enddate!==undefined && this.state.enddate!=='' ))
              {                      
              this.setState({date:Date.parse(new Date(this.convertPSTDateToUTCTimezone(new Date(this.state.date)))) , 
                enddate:Date.parse(new Date(this.convertPSTDateToUTCTimezone(new Date(this.state.enddate)))) });
              }
            }
            else if(selectedtimezone==="CST")
            {         
              if((this.state.date!==null && this.state.date!==undefined && this.state.date!=='') && (this.state.enddate!==null && this.state.enddate!==undefined && this.state.enddate!=='' ))
              {
              this.setState({date:this.convertPSTDateToCST(new Date(this.state.date)) , 
                enddate:this.convertPSTDateToCST(new Date(this.state.enddate)) });   
              }          
                            
            }
       }            

    }
  
  
    checkErrors = () => {
    
        const validEmailRegex = 
        RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);  
      const {title,date,enddate,category,region,country} = this.state;
      var obj = {};
      const { userEmail} = this.props;
     
          
      if (title.length === 0) {
        this.setState({
          titleError: 'Event title should not be blank.'
        })
        obj.prop = ++obj.prop || 0;
  
      }
      if (category.length === 0 || category===null) {
        this.setState({
          categoryError: 'Event Category should be selected.'
        })
        obj.prop = ++obj.prop || 0;
  
      }
    
    /*  if (region.length === 0 || region===null) {
        this.setState({
          regionError: 'Region should be selected.'
        })
        obj.prop = ++obj.prop || 0;
  
      }
      if (country.length === 0 || country===null) {
        this.setState({
          countryError: 'Country should be selected.'
        })
        obj.prop = ++obj.prop || 0;
  
      } */
         
      if (date === '') {
        this.setState({
          dateError: 'Start Date field should not be blank.'
        })  
        obj.prop = ++obj.prop || 0;
      }
      else if(date)
      {
     //   var m = moment(date, 'YYYY-MM-DD');
        var m = moment(date, 'dd-mmm-yyyy');   

        if(m.isValid() === false)
        {
            this.setState({
                dateError: 'Start Date format is (mm/dd/yyyy hh(12 hour):mm am/pm)'
              })  
              obj.prop = ++obj.prop || 0; 
        } 
        // if( Date.parse(new Date(new Date().toUTCString()).toUTCString()) > Date.parse(this.convertDateToUTC(new Date(date))))
        // {
        //   this.setState({
        //     dateError: 'Start Datetime is less than current UTC Datetime'
        //   })  
        //   obj.prop = ++obj.prop || 0;
        // }
      } 
  
      if (enddate === '') {
        this.setState({
          enddateError: 'End Date field should not be blank.'
        })  
        obj.prop = ++obj.prop || 0;
      }
      else if(moment(enddate, 'YYYY-MM-DD').isValid() === false)
      {
            this.setState({
              enddateError: 'End Date format is (mm/dd/yyyy hh(12 hour):mm am/pm)'
              })  
              obj.prop = ++obj.prop || 0; 
      
      }
      else if(date && enddate)
      {
        
        if (Date.parse(new Date(this.convertDateToUTC(new Date(date)))) > Date.parse(new Date(this.convertDateToUTC(new Date(enddate))))) {
          this.setState({
            enddateError: 'End Datetime should be greater than or equal to Start Datetime.'
          })  
          obj.prop = ++obj.prop || 0;
        }
        var startdatecompare = moment(date, "YYYY-MM-DD HH:mm:ss");
        var enddatecompare = moment(enddate, "YYYY-MM-DD HH:mm:ss");
        var diff = enddatecompare.diff(startdatecompare, 'h'); // Diff in hours
        if (diff > 72) {
          this.setState({
            enddateError: 'the period should not be superior to 72 hours'
          })  
          obj.prop = ++obj.prop || 0;
        }
       
      }          
    
      if(obj.prop >=0)
      {
      return true;
      }
      else
      {
      return false;
      }
    } 
  
    renderError(name) {
      const { titleError,
        dateError,enddateError,categoryError,regionError,countryError} = this.state;
      switch(name) {
        case 'title':
          if (titleError) {
            return <div style ={{backgroundColor:'#f8d7da'}}>{titleError}</div>;
          }
          break;        
        case  'category' :
          if (categoryError) {
            return <div style ={{backgroundColor:'#f8d7da'}}>{categoryError}</div>;
          }
          break;         
        case  'date' :
           if (dateError) {
              return <div style ={{backgroundColor:'#f8d7da'}}>{dateError}</div>;
          }
          break;
  
        case  'enddate' :
            if (enddateError) {
               return <div style ={{backgroundColor:'#f8d7da'}}>{enddateError}</div>;
           }
           break; 
        case  'region' :
            if (regionError) {
              return <div style ={{backgroundColor:'#f8d7da'}}>{regionError}</div>;
            }
            break;  
        case  'country' :
                if (countryError) {
                  return <div style ={{backgroundColor:'#f8d7da'}}>{countryError}</div>;
                }
                break;  
       
        default: 
        break;       
          
        }    
      
    }
  
    
    showDialog = async () => {
      this.setState({showDialog : true});
    };

     showErrorDialog = async () => {
        this.setState({showErrorDialog : true});
      };

      showEventErrorDialog = async () => {
        this.setState({showEventErrorDialog : true});
      };

      flip = async() => 
     {
      this.setState({showNewDialog:!this.state.showNewDialog})
     }

     

      cofirmApproveReject = async() =>
      {      

        const newState = this;
        const bodyvalues = newState.state.addOutage;  
        var token = await fetchToken();  
        var correlationId = uuid.v1(); 
        var bearer = 'Bearer ' + token;   
        var apimVerifyDataUrl = window.env.APIMURL + "/api/outage/verifyfactoryproductiondata"; 
        var apimUrlAddEvent = window.env.APIMURL + "/api/outage/addoutage";  
        
        trackPromise(
        
          fetch(apimVerifyDataUrl, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'CorrelationId': correlationId,
            'authorization': bearer,
            },
           body: bodyvalues
          }).then(response => {
            return response.json()
                })              
          .then( async val => {
              this.setState({
              result:val
              }); 
              
              if(this.state.result===0)  //this means there is no such data . 
              {
                fetch(apimUrlAddEvent, {
                  method: 'POST',
                  headers: {
                  //'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'CorrelationId': correlationId,
                  'authorization': bearer,
                  },
                 body: bodyvalues
                }).then(response => {
                  return response.json()
                      })              
                .then(async returnId => {
                  if (this._isMounted) {
                          this.setState({
                    result:returnId,
                    addevent : true                   
                  });
                  var values = JSON.parse(bodyvalues);           
                  values["outageId"] = returnId;
                  values["start"] = new Date(values.StartTime);
                  values["end"] = new Date(values.EndTime);
                  values["holidayName"] = values.title;                         
                  newState.props.addEvent(values);                            
                  newState.setState({
                    date: '',
                    enddate:'',
                    holidayName:''                                                 
                   });              
                   await newState.showDialog();      
                }
               })
               .catch( async error =>
                      {
                        //alert("Error Occured");  
                        await this.showErrorDialog();
                        var err = 
                        {
                            "message": "Exception occured while submitting a factory production event.",
                            "ComponentId" : COMPONENT_ID,
                            "ComponentName" : COMPONENT_NAME,
                            "EnvironmentName" : window.env.ENVIRONMENT,
                            "ServiceLineName" : SERVICE_LINE,
                            "ServiceName" : SERVICE_NAME,
                            "ServiceOfferingName" : SERVICE_OFFERING,
                            "Component" : "Calendar Add Factory Production Event Page",
                            "exception": error.message,
                            "Correlation Id": correlationId
                        }               
                       appInsights.trackException({exception: error,properties : err});  
                     })
              }
              else //this means data already exists .
              {
                await this.showEventErrorDialog();
              }                            
          })
          .catch( async error =>
                {
                  //alert("Error Occured");  
                  await this.showErrorDialog();
                  var err = 
                  {
                      "message": "Exception occured while validating factory production event in BI ",
                      "ComponentId" : COMPONENT_ID,
                      "ComponentName" : COMPONENT_NAME,
                      "EnvironmentName" : window.env.ENVIRONMENT,
                      "ServiceLineName" : SERVICE_LINE,
                      "ServiceName" : SERVICE_NAME,
                      "ServiceOfferingName" : SERVICE_OFFERING,
                      "Component" : "Calendar Add Event Page",
                      "exception": error.message,
                      "Correlation Id": correlationId
                  }               
                 appInsights.trackException({exception: error,properties : err});  
               })            
             );           
    }
  
    submitAlert = async(event) =>{
      this.setState({showNewDialog:!this.state.showNewDialog})
     
    }

    approveDialog = async(event) => {
      this.setState( {showNewDialog: false});  
      var event = await this.cofirmApproveReject(event);    
    }

    cancelDialog = async () => {
      const { onClickCancel } = this.props;
      if (typeof onClickCancel === "function") { await onClickCancel(); }
      this.setState( {showNewDialog: false});
    }
    
    
      methodInvoke = async(event) =>
      {  
        let errors = null;
      try {   
        event.preventDefault();
        event.persist();
        this.setState({region:event.target.region.value,country:event.target.country.value}); 
        if(this.checkErrors())
        {
          
          this.props.submitModalPopUpFunc(true);
          return;
        }
        else
        {   
          
                var title = event.target.title.value;
                var startdate = moment(this.state.date, 'YYYY-MM-DDTHH:mm:ss.fff Z');
                startdate = startdate.format('YYYY-MM-DDTHH:mm:ss');       
                var EndTime= moment(this.state.enddate, 'YYYY-MM-DDTHH:mm:ss.fff Z');
                EndTime = EndTime.format('YYYY-MM-DDTHH:mm:ss');       
                //var org = event.target.organization === undefined ? null : '';
                const { userEmail} = this.props;
                var selectedtimezone=this.state.timezone;  
                //var NACAT = val              
                var NACAT = getTestparvalue()
       
                var bodyvalues = JSON.stringify({
                     title: title,
                     Description: '',
                     StartTime: startdate,
                     EndTime: EndTime,
                     organization: 'Pegatron',
                     ExternalContact: null,
                     outageType: 'Planned',      
                     Impact : '',
                     engContact: userEmail,
                     pmContact: "samp_bi_pm@microsoft.com",
                     teamgroup:'MAKE Factory Services (Redmond)',
                     service:'Factory Systems',
                     component:null,
                     servicegroup:'SCE Factory Systems',
                     division:"Core Services Engineering and Operations",
                     orgName:"Core Platform Engineering",
                     eventstatus:"",
                     NextSteps:"",
                     //NACategory: "JDM1 Production Calendar",
                     NACategory: NACAT,
                     category:(this.state.category!==''||this.state.category!==null)?this.state.category.value:'',
                     Location:'',
                     Recurrence:false,
                     factoryName: event.target.factory === undefined ? 'JDM1' : this.state.factory.value,
                     region: event.target.region.value==='--Select Region--'?'Asia':event.target.region.value,
                     country: event.target.country.value==='--Select Country--'?'China':event.target.country.value,
                     timezone:selectedtimezone
                 }) 
                 this.setState({addOutage:bodyvalues});
                 var event = await this.submitAlert(event); 
                 
                }
      
      
    }
    catch (e) {
      errors = e;
  }
     //Catch Block
  }
       
     
      handleChange(e){
        // if(e.target.value.match("^[a-zA-Z ]*$")!=null) {
         this.setState({[e.target.name]: e.target.value, [`${e.target.name}Error`]:  '' })
        //}
      }
     
  
    
    onChange(date)
    {     
      this.setState({ date:date, dateError :''})
    }
  
    onEndChange(date)
    {
      this.setState({enddate:date,enddateError:''})
    }
  
  
    closeDialog= async () => {
      this.setState( {showDialog: false,showErrorDialog: false,showHolidayErrorDialog:false} );
      this.props.submitModalPopUpFunc(false); 
    }
  
     
    componentDidCatch(error, info) {
      
      // Display fallback UI
      this.setState({ hasError: true });
      // You can also log the error to an error reporting service
      //logErrorToMyService(error, info);
    } 


    async updateFactoryName(value){
      
      this.setState({factory: value });
      
    }

    async setFactoryError(value){
      
      this.setState({
          factoryError: value
         });
    }

/*    async updateRegion(value){
      
      this.setState({region: value });
      
    }

    async setRegionErrorValue(value){
      
      this.setState({
          regionError: value
         });
    }

    async updateCountry(value){
      
      this.setState({country: value });
      
    }

    async setCountryErrorValue(value){
      
      this.setState({
          countryError: value
         });
    } */

        
    handleCategoryChange = async(category) => {
      await this.setState(
        { category,categoryError:''},
        () => console.log(`Option selected:`, this.state.category)
      );
     // await this.props.holidayType(holidayType);
     // await this.props.setHolidayTypeError(this.state.holidayTypeError);
      
    };

    async updateCategory(value){
      
      this.setState({category: value });
      
    }

    async setCategoryError(value){
      
      this.setState({
        categoryError: value
         });
    }
    
    
    
   render(){
     const { userEmail} = this.props;
    
     const categoryArray=[
        { value: 'Production', label: 'Production' },
        { value: 'Physical Inventory Count', label: 'Physical Inventory Count' },
        { value: 'Partial Production', label: 'Partial Production' },
        { value: 'OT', label: 'OT' },
        { value: 'Holiday', label: 'Holiday' }
      ];

      let inputProps = {
        placeholder: "Select a Date"        
      };

      return (      
        <div> 
          <AlertDialog title= {'Confirmation Dialog'} message= {'Are you sure you want to submit?'} open={this.state.showNewDialog}
           okButtonLabel = {'Yes'} okButtonType = {ButtonType.Danger} cancelButtonLabel={'No'}
          cancelButtonType={ButtonType.Danger} onClickCancel={this.cancelDialog} onClickOk={this.approveDialog}/>
          <AlertDialog  title= {'Success!'} cancelButtonLabel={'Ok'}
                          message= {'Factory Production Event added successfully'} open={this.state.showDialog} onClickCancel={this.closeDialog}/>  
          <AlertDialog  title= {'Error'} cancelButtonLabel={'Ok'}
                          message= {'Insufficient Access'} open={this.state.showErrorDialog} onClickCancel={this.closeDialog}/>    
          <AlertDialog  title= {'Error'} cancelButtonLabel={'Ok'}
                          message= {'Factory Production event already exists in MS record.'} open={this.state.showEventErrorDialog} onClickCancel={this.closeDialog}/>    
          
          <Modal style = {{'overflow': 'visible'}} role="dialog" aria-label="createnewfactoryproductionevent" data-keyboard="false" show={this.props.show} size="lg" onHide ={()=> {this.props.submitModalPopUpFunc(false)}}  backdrop="static" centered autoFocus="true">       
            <Modal.Header closeButton>
              <Modal.Title>Create New Factory Production Event</Modal.Title>
            </Modal.Header>
            <LoadingIndicator></LoadingIndicator>
            <form id = "addevent" onSubmit={this.methodInvoke.bind(this)}>
              <Modal.Body style={{'maxHeight': 'calc(100vh - 210px)',  'overflowY': 'auto'}}>                        
              <div className="form-group required">
                <label htmlFor="title" class="control-label">Title</label>
                <input required aria-label="title" type="text" placeholder="title" className="form-control" name="title" value={this.state.title ||""} onChange={(e) => this.handleChange(e)}/>
                <span style={{color: '#E22335'}}>{this.renderError('title')}</span>
              </div>
              
              <div className="form-group required">
              <label htmlFor="category" class="control-label">Category</label>
                <Select  required aria-label="category" name="category" title="Select Category" 
                    isMulti = {false}
                    value={this.state.category}
                    onChange={this.handleCategoryChange} 
                    options={categoryArray}  >              
                                 
                </Select>               
                <span style={{color: '#E22335'}}>{this.renderError('category')}</span>            
              </div>  

              <div  className="form-group required">
               
               <label> Timezone : </label>
               &nbsp;
               <input type="radio" value="UTC" name="radio-group"  placeholder="UTC" defaultChecked onChange={this.onTimezoneChange}/> UTC
               &nbsp;
               <input type="radio" value="PST" name="radio-group" placeholder="PST" checked={this.state.timezone === "PST"} onChange={this.onTimezoneChange}/> PST 
               &nbsp;
               <input type="radio" value="CST" name="radio-group" placeholder="CST" checked={this.state.timezone === "CST"} onChange={this.onTimezoneChange}/> CST
               &nbsp;           
             </div> 

              <div className="form-group required">              
                <label htmlFor="date" class="control-label">StartDate</label>      
                  <Datetime required inputProps={inputProps}  calendarAriaLabel="StartDateCalender" yearAriaLabel="Year" monthAriaLabel="Month" dayAriaLabel="Day" hourAriaLabel="Hour" minuteAriaLabel="Minute" amPmAriaLabel="ampm"
                 name="date" dateFormat="DD-MMM-YYYY" onChange={this.onChange} value={this.state.date || "" }></Datetime>  
                {/* <DateTimePicker style = {{'z-index': '1600 !important;'}} className="form-control" name="date" onChange={this.onChange} value={this.state.date ||""}/>  */}
                <span style={{color: '#E22335'}}>{this.renderError('date')}</span>
                           
              </div>
              <div className="form-group required">
                <label htmlFor="enddate" class="control-label">EndDate</label>
                <Datetime required inputProps={inputProps} calendarAriaLabel="EndDateCalender" yearAriaLabel="Year" monthAriaLabel="Month" dayAriaLabel="Day" hourAriaLabel="Hour" minuteAriaLabel="Minute" amPmAriaLabel="ampm"
                 name="enddate" dateFormat="DD-MMM-YYYY" onChange={this.onEndChange} value={this.state.enddate || "" }></Datetime>
                {/* <DateTimePicker clearAriaLabel="EndTime" calendarAriaLabel="EndTimeCalender" yearAriaLabel="Year" monthAriaLabel="Month" dayAriaLabel="Day" hourAriaLabel="Hour" minuteAriaLabel="Minute" amPmAriaLabel="ampm"
                className="form-control" name="endtime" onChange={this.onEndChange} value={this.state.enddate ||""}/>  */}
                <span style={{color: '#E22335'}}>{this.renderError('enddate')}</span>
              </div>

                    <div className="form-group required">
                    <ReactFactoryDropDown
                          
                        factoryData={this.updateFactoryName.bind(this)}
                        email = {userEmail}      
                        factoryError = {this.renderError('factory')}
                        setfactoryError={this.setFactoryError.bind(this)}                                        
                    />

                    <div className="form-group required">    
                        <ReactRegionDropDown 
                        email = {userEmail} 
                        country = {this.state.country} 
                        region = {this.state.region}/>
                    </div>
                      
                    </div>
                    
              </Modal.Body>
              
            <Modal.Footer>
              <Button aria-label="Close" variant="secondary" onClick={()=> {this.props.submitModalPopUpFunc(false)}}>
                Close
              </Button>
              <Button aria-label="Submit Outage" form = "addevent" type="submit" variant="primary" onClick = {()=> {this.props.submitModalPopUpFunc(true)}}>
                Submit
              </Button>
              
            </Modal.Footer> 
            </form>       
          </Modal>
          
        </div>
    );
    }
  }

export default AddFactoryProductionEvent;